/* TILOA — comportements de la fiche « Chiffon TILOA » (gabarit product.chiffon), chargés par
   sections/tiloa-ch-tete.liquid. Aucune requête réseau, aucun ajout au panier, aucun événement de mesure.

   1. Barre collante (sections/tiloa-sticky-atc.liquid, réglages seulement) : la section affiche déjà
      le total du lot choisi (événement « tiloa:bundle-change » émis par assets/tiloa-ch-offres.js) et
      relaie son bouton vers le formulaire du module. Ce script y ajoute, sans toucher la section
      partagée, le prix barré du lot et son libellé (« 2 + 2 offerts »). La pastille « ×4 » de la
      section est masquée par la feuille de la fiche.
   2. Bouton retour en haut (rond sauge de 40 px) : visible au-delà de 400 px de défilement ; remonte
      au-dessus de la barre collante quand elle est affichée, et au-dessus de la carte cookies si elle
      le recouvre ; masqué sous 750 px (feuille de la fiche) ; défilement instantané si l'utilisateur
      réduit les animations.
   3. Liens vers #offre (« Choisir mon lot » des sections) : défilement doux jusqu'au module, focus
      sur la carte choisie, sans défilement supplémentaire. Aucun choix modifié.
   4. Ligne soulignée « 100 jours satisfait ou remboursé » : ouvre l'accordéon Garantie de la colonne
      d'achat et l'amène à l'écran.
   5. Note « 4,8/5 (2 300 avis) » : lien vers #avis seulement si la section avis est affichée ;
      sinon vers la FAQ (#faq), sinon la note n'est plus un lien.
   6. Galerie sur mobile : points sous forme de boutons (cible de 32 px) posés en bas de l'image,
      synchronisés avec le glissement ; les flèches du thème restent la commande principale.
   7. (01/11/2026) Bloc rareté : jauge remplie à l'apparition et décompte par visiteur (08:55:13 au départ). */
(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-suffix-chiffon')) return;
  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sansEchec(fn) { try { fn(); } catch (e) {} }

  /* ---------- 1. Barre collante : barré et libellé du lot ---------- */
  function barreCollante() {
    var dernier = null;
    function appliquer() {
      var bar = document.querySelector('.sticky-atc');
      if (!bar || !dernier) return;
      var meta = bar.querySelector('.sticky-atc__meta');
      if (!meta) return;
      var s = meta.querySelector('.ch-sticky__barre');
      if (!s) {
        s = document.createElement('s');
        s.className = 'ch-sticky__barre';
        meta.appendChild(s);
      }
      s.textContent = dernier.compareAtFormatted || '';
      if (dernier.compareAtFormatted) s.setAttribute('aria-label', 'au lieu de ' + dernier.compareAtFormatted);
      else s.removeAttribute('aria-label');
      var l = meta.querySelector('.ch-sticky__lot');
      if (!l) {
        l = document.createElement('span');
        l.className = 'ch-sticky__lot';
        meta.appendChild(l);
      }
      l.textContent = dernier.title && dernier.quantity > 1 ? dernier.title : '';
    }
    document.addEventListener('tiloa:bundle-change', function (e) {
      dernier = e.detail || null;
      appliquer();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', appliquer);
    else appliquer();
  }

  /* ---------- 2. Bouton retour en haut ---------- */
  function retourHaut() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ch-haut';
    b.setAttribute('aria-label', 'Revenir en haut de la page');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(b);
    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduit ? 'auto' : 'smooth' });
      var cible = document.getElementById('MainContent') || document.body;
      if (cible && cible.focus) {
        if (!cible.hasAttribute('tabindex')) cible.setAttribute('tabindex', '-1');
        try { cible.focus({ preventScroll: true }); } catch (e) {}
      }
    });

    var attente = false;
    function maj() {
      attente = false;
      var visible = (window.scrollY || window.pageYOffset || 0) > 400;
      var bas = 20;
      // Hauteur et décalage de la barre (et non sa boîte à l'écran : elle glisse pendant 0,15 s).
      var bar = document.querySelector('.sticky-atc.is-visible');
      if (bar && bar.offsetHeight > 0) {
        bas = Math.max(bas, Math.round(bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0)) + 20);
      }
      var dlg = document.querySelector('.shopify-pc__banner__dialog');
      if (dlg) {
        var cs = getComputedStyle(dlg);
        var r = dlg.getBoundingClientRect();
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.right > window.innerWidth - 80) {
          bas = Math.max(bas, Math.round(window.innerHeight - r.top) + 12);
        }
      }
      b.style.setProperty('--ch-haut-bas', bas + 'px');
      b.classList.toggle('is-visible', visible);
      b.tabIndex = visible ? 0 : -1;
    }
    function planifier() {
      if (attente) return;
      attente = true;
      window.requestAnimationFrame(maj);
    }
    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier, { passive: true });
    // Barre collante et carte cookies changent d'état sans défilement.
    new MutationObserver(planifier).observe(document.body, { childList: true, subtree: false });
    var bar = document.querySelector('.sticky-atc');
    if (bar) new MutationObserver(planifier).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.shopify-pc__banner__dialog')) setTimeout(planifier, 400);
    }, true);
    // Vitesse 25/10 : 1er calcul à l'image suivante (planifier), et non juste après l'ajout du
    // bouton (écriture puis lecture = mise en page forcée). Le bouton reste masqué jusque-là
    // (visibility: hidden sans « is-visible »), invisible sous 400 px de défilement.
    planifier();
  }

  /* ---------- 3. Liens vers le module d'offres ---------- */
  function liensOffre() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var i = href.indexOf('#');
      if (i < 0) return;
      var avant = href.slice(0, i);
      if (avant && avant !== window.location.pathname && avant !== window.location.href.split('#')[0]) return;
      var id = href.slice(i + 1);
      if (id !== 'offre') return;
      var cible = document.getElementById('offre');
      if (!cible) return;
      if (!a.hasAttribute('data-td-goto')) {
        e.preventDefault();
        cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
      }
      var radio = cible.querySelector('[data-ch-radio]:checked') || cible.querySelector('[data-ch-radio]');
      if (radio) setTimeout(function () { try { radio.focus({ preventScroll: true }); } catch (x) {} }, 0);
    });
  }

  /* ---------- 4. Ligne soulignée → accordéon Garantie ---------- */
  function ligneGarantie() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('[data-ch-ouvrir]');
      if (!a) return;
      var btn = document.getElementById(a.getAttribute('data-ch-ouvrir'));
      if (!btn) {
        var rang = parseInt(a.getAttribute('data-ch-ouvrir-rang'), 10) || 0;
        var tous = document.querySelectorAll('.product__info-container .td-fq .td-fq__btn');
        btn = rang > 0 ? tous[rang - 1] : null;
      }
      if (!btn) return; // repli : l'ancre du lien
      e.preventDefault();
      var item = btn.closest('.td-fq__item');
      if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
      if (item) {
        item.classList.add('ch-cible');
        setTimeout(function () { item.classList.remove('ch-cible'); }, 1600);
      }
      (item || btn).scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { try { btn.focus({ preventScroll: true }); } catch (x) {} }, 0);
    });
  }

  /* ---------- 5. Lien de la note ---------- */
  function lienNote() {
    var liens = document.querySelectorAll('.product__info-container .tiloa-rating-line a.tiloa-rs__main[href^="#"]');
    Array.prototype.forEach.call(liens, function (a) {
      var id = a.getAttribute('href').slice(1);
      if (id && document.getElementById(id)) return;
      if (document.getElementById('faq')) { a.setAttribute('href', '#faq'); return; }
      a.removeAttribute('href');
    });
  }

  /* ---------- 6. Points de la galerie (mobile) ---------- */
  function pointsGalerie() {
    var viewer = document.querySelector('.product__media-wrapper slider-component[id^="GalleryViewer"]');
    if (!viewer) return;
    var liste = viewer.querySelector('.product__media-list');
    if (!liste) return;
    var slides = Array.prototype.slice.call(liste.querySelectorAll(':scope > .product__media-item'));
    if (slides.length < 2) return;
    var nav = document.createElement('div');
    nav.className = 'ch-dots';
    nav.setAttribute('role', 'group');
    nav.setAttribute('aria-label', 'Images du produit');
    var points = slides.map(function (s, i) {
      var p = document.createElement('button');
      p.type = 'button';
      p.className = 'ch-dots__btn';
      p.setAttribute('aria-label', 'Image ' + (i + 1) + ' sur ' + slides.length);
      // Vitesse 25/10 : état de départ posé à la création (1re image active), celui que
      // donne maj() quand la galerie est au début ; maj() est ensuite appelée à l'image suivante.
      p.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      p.addEventListener('click', function () {
        var x = s.offsetLeft - liste.offsetLeft;
        liste.scrollTo({ left: x, behavior: reduit ? 'auto' : 'smooth' });
      });
      nav.appendChild(p);
      return p;
    });
    viewer.appendChild(nav);
    var attente = false;
    function maj() {
      attente = false;
      var gauche = liste.scrollLeft;
      var meilleur = 0, ecart = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs((s.offsetLeft - liste.offsetLeft) - gauche);
        if (d < ecart) { ecart = d; meilleur = i; }
      });
      points.forEach(function (p, i) { p.setAttribute('aria-current', i === meilleur ? 'true' : 'false'); });
    }
    liste.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      window.requestAnimationFrame(maj);
    }, { passive: true });
    // Vitesse 25/10 : lecture des positions (offsetLeft) à l'image suivante, et non juste
    // après l'ajout des points (écriture puis lecture = mise en page forcée).
    window.requestAnimationFrame(maj);
  }

  /* ---------- 7. Bloc rareté (snippets/tiloa-ch-rarete.liquid, 01/11/2026, décision du propriétaire) ----------
     Jauge : repart de zéro et se remplit (transition CSS) la première fois que le bloc est bien visible ; sans
     IntersectionObserver ou si l'utilisateur réduit les animations, elle reste pleine.
     Décompte par visiteur : à la première visite, échéance = maintenant + data-duree (08:55:13), gardée dans le
     navigateur (localStorage, lecture et écriture protégées) pour continuer d'une page à l'autre. Échéance absente,
     passée ou plus longue qu'un cycle : nouveau cycle. À zéro, un nouveau cycle commence. Une mise à jour par
     seconde, calée sur le changement de seconde ; arrêt quand l'onglet est caché, reprise au retour. */
  function rarete() {
    var bloc = document.querySelector('[data-ch-rarete]');
    if (!bloc) return;

    var jauge = bloc.querySelector('[data-ch-jauge]');
    if (jauge && !reduit && 'IntersectionObserver' in window) {
      jauge.setAttribute('data-ch-jauge', 'attente');
      var io = new IntersectionObserver(function (entrees) {
        if (!entrees.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        // Deux images : l'état « zéro » est peint avant le remplissage, la transition se joue donc toujours.
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { jauge.setAttribute('data-ch-jauge', ''); });
        });
      }, { threshold: 0.6 });
      io.observe(jauge.parentNode);
    }
    // Reflet de la jauge en pause tant que le bloc est hors écran (batterie, fluidité du défilement).
    if (jauge && !reduit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        var vu = entrees[entrees.length - 1].isIntersecting;
        if (vu) bloc.removeAttribute('data-ch-hors-ecran');
        else bloc.setAttribute('data-ch-hors-ecran', '');
      }).observe(bloc);
    }

    var fin = bloc.querySelector('[data-ch-rarete-fin]');
    var cible = bloc.querySelector('[data-ch-compteur]');
    var duree = parseInt(bloc.getAttribute('data-duree'), 10);
    if (!fin || !cible || !(duree > 0)) return;
    var CLE = 'tiloa-ch-rarete-fin';
    var cycle = duree * 1000;
    function lire() { try { return parseInt(window.localStorage.getItem(CLE), 10) || 0; } catch (e) { return 0; } }
    function garder(v) { try { window.localStorage.setItem(CLE, String(v)); } catch (e) {} }
    var echeance = lire();
    function nouveauCycle() { echeance = Date.now() + cycle; garder(echeance); }
    if (!echeance || echeance <= Date.now() || echeance - Date.now() > cycle + 1000) nouveauCycle();

    function deux(n) { return (n < 10 ? '0' : '') + n; }
    function ecrire(t) {
      var cases = cible.children;
      var i;
      if (cases.length !== t.length) {
        cible.textContent = '';
        for (i = 0; i < t.length; i++) {
          var c = document.createElement('span');
          c.className = t.charAt(i) === ':' ? 'ch-s' : 'ch-c';
          c.textContent = t.charAt(i);
          cible.appendChild(c);
        }
        return;
      }
      for (i = 0; i < t.length; i++) if (cases[i].textContent !== t.charAt(i)) cases[i].textContent = t.charAt(i);
    }
    function afficher() {
      var r = Math.ceil((echeance - Date.now()) / 1000);
      if (r <= 0) { nouveauCycle(); r = duree; }
      ecrire(deux(Math.floor(r / 3600)) + ':' + deux(Math.floor(r / 60) % 60) + ':' + deux(r % 60));
    }
    var minuteur = 0;
    function arreter() { if (minuteur) { clearTimeout(minuteur); minuteur = 0; } }
    function planifier() {
      arreter();
      if (document.hidden) return;
      // Réveil juste après le prochain changement de seconde du décompte (20 ms de marge).
      var attente = ((echeance - Date.now()) % 1000 + 1000) % 1000 || 1000;
      minuteur = setTimeout(function () { minuteur = 0; afficher(); planifier(); }, attente + 20);
    }
    function reprendre() {
      if (document.hidden) { arreter(); return; }
      afficher();
      planifier();
    }
    afficher();
    fin.hidden = false;
    planifier();
    document.addEventListener('visibilitychange', reprendre);
    window.addEventListener('pageshow', function (e) { if (e.persisted) reprendre(); });
  }

  sansEchec(barreCollante);
  function demarrer() {
    sansEchec(retourHaut);
    sansEchec(liensOffre);
    sansEchec(ligneGarantie);
    sansEchec(lienNote);
    sansEchec(pointsGalerie);
    sansEchec(rarete);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
